import React, { Component } from 'react'
import { compose } from 'redux'
import { firestoreConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import { connect } from 'react-redux'
import Preloader from './Preloader'
import parse from 'html-react-parser'
import highlight from 'highlight.js'
import 'highlight.js/scss/dracula.scss'
import clamp from 'line-clamp'

export class BlogPage extends Component {

  componentDidMount () {
      document.addEventListener('scroll', () => {
        if (document.querySelector('.blog-page')) {

          if (window.pageYOffset >= document.querySelector('.blog-title').offsetTop + document.querySelector('.blog-title').offsetHeight) {
            document.querySelector('.blog-navbar-title').textContent = this.props.blogs[0].title
            document.querySelector('.page-title-main').classList.add('blog-title-hidden')
            document.querySelector('.blog-navbar-title').classList.remove('blog-title-hidden')
            clamp(document.querySelector('.blog-navbar-title'), 1)
          }
          else {
            document.querySelector('.page-title-main').classList.remove('blog-title-hidden')
            document.querySelector('.blog-navbar-title').classList.add('blog-title-hidden')
          }
        }
      }) 
  }

  componentDidUpdate () {
    document.querySelectorAll('pre code').forEach(cur => {
      console.log('run')
      console.log(cur)
      highlight.highlightBlock(cur)
    })
  }

  render() {


    const { blogs } = this.props
    let blog
    if (isLoaded(blogs)) {
      blog = blogs[0]
    }
    

    return (
      <div className="blog-page animated fadeIn delay-1s">
        {
          !isLoaded(blog) || isEmpty(blog) ? <Preloader /> : (
            <div className="blog-content-wrapper">
              <div className="blog-title">
                <span>{ blog.title } </span>
              </div>
              <div className="blog-content">
                
                <div className="blog-article">{
                  parse(blog.content.html)
                }</div>
              
                
              </div>
            </div>  
          )
        }
      </div>
    )
  }
}

export default compose(
  firestoreConnect(props => [{
    collection: 'blogs',
    where: ['url', '==', props.match.params.slug],
  }]),
  connect (state => {
    return {
      blogs: state.firestore.ordered.blogs
    }
  })
)(BlogPage)



// find pre (queryselector) -> innerHTML (content) -> Prism.highlightAll (state.content) -> pre.innerHTML = state.content